import {css} from '@emotion/react'
import React, {ChangeEvent, useEffect, useState} from 'react'
import axios from 'axios'
import {TopNavBar} from 'appmodule/login/component/TopNavBar'
import {Button, Checkbox, TextField} from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment'
import {getVisibilityIcon} from 'util/getVisiblityEyeIcon'
import FormControlLabel from '@mui/material/FormControlLabel'
import {isMobile} from 'react-device-detect'
import {extractErrorFromUrl} from 'appmodule/login/utils/extractErrorFromUrl'
import Link from '@mui/material/Link'
import {log} from 'common/log'
import PersonIcon from '@mui/icons-material/Person';
import HttpsIcon from '@mui/icons-material/Https';
import {alertServerError, ConfirmDialogContainer} from 'module/ConfirmDialog/component/ConfirmDialogContainer'

const cssForm = css`
	min-height: 220px;
	width: 100%;
`
export const cssApp = css`
	min-width: 40%;
	display: flex;
	justify-content: space-around;
	margin: 25px;
	padding: 25px;
	align-self: center;
`
export const cssPsw = css`
	width: ${isMobile ? 100 : 40}%;
	padding: 25px;
	margin: 10px;
	border: 1px solid #cccccc;
	border-radius: 10px;
`
export const cssContainer = css`
	width: 100%;
	padding-top: 12px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5px;
`

export const cssError = css`
	color: #dc6a6a;
`
const LOGIN_URL = "../pages/j_spring_security_check";
const SHOW_RESET_PROP_URL = "../noauth/props/reset";
const SHOW_RESET_PROP_NAME = "showResetLink";

export const LoginComponent = () => {
	const [user, setUser] = useState('');
	const [pwd, setPwd] = useState('');
	const [remember, setRemember] = useState(false);
	const [error, setError] = useState<string | null>();
	const [viewPwd, setViewPwd] = useState<boolean>(false)
	const [recovery, setRecovery] = useState<boolean>(true)

	useEffect(() => {
		axios.get(SHOW_RESET_PROP_URL)
			.then(({data}) => data)
			.then(({props}) => {
				let srl: string = props[SHOW_RESET_PROP_NAME];
				setRecovery(srl?.toUpperCase() === 'J')
			})
			.catch(e => {
				log.error('error: ' + e?.message);
				setRecovery(false)
			})
	}, []);

	const onLogin = () => {
		try {
			const params = new URLSearchParams();
			params.append('j_username', user);
			params.append('j_password', pwd);
			params.append('remember-me', remember ? 'true' : 'false');

			axios.post(LOGIN_URL, params)
				.then((resp) => {
					setUser('');
					setPwd('');
					setError(null);
					if (resp?.status === 200 && resp?.data) {
						if (resp?.request.responseURL) {
							let err = extractErrorFromUrl(resp?.request.responseURL);
							if (err) {
								setError(err);
							} else {
								window.location.replace(resp?.request.responseURL);
							}
						}
					}
				}).catch(e => {
				void alertServerError(e, "Fehler beim Anmeldeversuch")
			})
		} catch (e) {
			void alertServerError(e, "Sonstige Fehler: " + e?.message );
		}
	}

	return <>
		<ConfirmDialogContainer/>
		<TopNavBar/>
		<div css={cssApp}>
			<div css={cssPsw}>
				<form noValidate autoComplete="off" css={cssForm} action={LOGIN_URL}>
					<TextField
						id={"userName"}
						value={user}
						fullWidth
						required
						autoFocus
						autoComplete="username"
						variant="standard"
						label={"Benutzer"}
						sx={{mb: 2}}
						onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setUser(event.target.value)}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<PersonIcon/>
								</InputAdornment>
							),
						}}
					/>
					<TextField
						id={"password"}
						value={pwd}
						fullWidth
						required
						onKeyDown={(e: any) => {
							if (e.key === 'Enter') {
								onLogin();
							}
						}}
						type={viewPwd ? "text" : "password"}
						variant={'standard'}
						label={"Passwort"}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<HttpsIcon/>
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment id={"viewPassword"} position="start"
																onClick={() => setViewPwd(prevState => !prevState)}>
									{getVisibilityIcon(viewPwd)}
								</InputAdornment>
							),
						}}
						onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setPwd(event.target.value)}
					/>
					<FormControlLabel
						label={"Angemeldet bleiben"} sx={{mt: 2}}
						control={<Checkbox id="remember"
															 value={remember}
															 style={{color: "rgb(55, 103, 152)"}}
															 onChange={(event) => setRemember(event.target.checked)}/>}/>
					<div css={cssContainer}>
						<Button style={{}} onClick={onLogin} sx={{color: 'black'}}>Anmelden</Button>
						{recovery &&
							<Button size={'small'} component={Link} href={"../pages/recovery.jsp"}>Passwort vergessen?</Button>}
						{error && <div css={cssError}>{error}</div>}
					</div>
				</form>
			</div>
		</div>
	</>
};
